console.log('CUSTOM DISCOUNT JS LOADED');

let appliedDiscountCodes = [];

// Get currently applied discount codes from Shopify
async function loadAppliedDiscountCodes() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to load cart');
    }

    const cart = await response.json();

    appliedDiscountCodes = (cart.discount_codes || [])
      .map(item => item.code.trim().toLowerCase())
      .filter(Boolean);

    console.log('Applied discount codes:', appliedDiscountCodes);

  } catch (error) {
    console.error('Unable to check cart discounts:', error);
  }
}


// Load applied discounts when the page loads
loadAppliedDiscountCodes();


// When the theme reloads the cart
document.addEventListener('cartReload', function () {

  setTimeout(function () {

    // Clear any previous discount error
    document.querySelectorAll('[data-cart-discount-error]').forEach(function (error) {
      error.style.display = 'none';
      error.textContent = '';
    });

    // Get the latest applied discounts
    loadAppliedDiscountCodes();

  }, 300);
});


// Capture the discount Apply button before global.js handles it
document.addEventListener('click', function (event) {

  const button = event.target.closest('[data-cart-discount-apply]');

  if (!button) {
    return;
  }

  const discountBox = button.closest('hdt-cart-discount');

  if (!discountBox) {
    return;
  }

  const input = discountBox.querySelector('[data-cart-discount-input]');
  const error = discountBox.querySelector('[data-cart-discount-error]');

  if (!input || !error) {
    return;
  }

  const enteredCode = input.value.trim().toLowerCase();

  if (!enteredCode) {
    return;
  }


  // Clear any previous error message
  error.style.display = 'none';
  error.textContent = '';


  // Check whether this coupon is already applied
  if (appliedDiscountCodes.includes(enteredCode)) {

    // Stop the original global.js handler
    event.preventDefault();
    event.stopImmediatePropagation();

    // Show duplicate coupon error
    error.textContent = 'Code already added.';
    error.style.display = 'block';

    console.log('Duplicate discount blocked:', enteredCode);

    return;
  }


   // If this is a new coupon, do nothing.
  // The existing global.js will handle it normally.
  // Refresh applied discount list shortly after any apply attempt,
  // in case the theme's cartReload event doesn't fire in time.
  // Take over the whole apply flow ourselves — stop the theme's default handler
  setTimeout(loadAppliedDiscountCodes, 800);
  event.preventDefault();
  event.stopImmediatePropagation();

  button.disabled = true;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: enteredCode })
  })
    .then(res => res.json())
    .then(cart => {
      const codes = cart.discount_codes || [];
      const match = codes.find(d => d.code.trim().toLowerCase() === enteredCode);

      if (match && match.applicable) {
        // Success — reload so totals/discount UI update everywhere
        window.location.reload();
      } else {
        // Invalid or inapplicable code
        error.textContent = 'This discount code is invalid.';
        error.style.display = 'block';
        button.disabled = false;
      }
    })
    .catch(() => {
      error.textContent = 'Something went wrong. Please try again.';
      error.style.display = 'block';
      button.disabled = false;
    });

}, true);
